import { QrCode, Text } from '@sloyd/ui';
import { Wrapper } from './ModalMobile.style';

export type ModalMobileProps = {
  url: string;
};

export function ModalMobile(props: ModalMobileProps) {
  const { url } = props;

  return (
    <Wrapper className='ModalMobile-wrapper' data-testid='ModalMobile-wrapper'>
      <Text size='sm'>Scan this QRCode to view the model on your mobile phone:</Text>
      <QrCode value={url} />
    </Wrapper>
  );
}

export default ModalMobile;
